import { render } from "./Saving_Transfers.vue?vue&type=template&id=e41a005c"
import script from "./Saving_Transfers.vue?vue&type=script&lang=js"
export * from "./Saving_Transfers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__